import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';

import {
  StyledSection,
  HeroVideoContainer,
  HeroWrapper,
  HeroCloudImage,
  HeroTextPairing,
  StyledGetStartedButton,
  StyledButton,
  RegistryHeroTextColumn,
  ButtonsContainer,
} from './ExternalBrandHeroSection.styles';
import { getRootUrl } from '@utils/urlHelpers.util';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

interface ExternalBrandHeroSectionProps {
  idPrefix: string;
  page: MarcomPageName;
  heroImageData: { heroImage: string; heroImageMobile: string };
  brand: string;
  heroData: Record<string, string>;
}

export const ExternalBrandHeroSection = ({ idPrefix, heroImageData, heroData, page, brand }: ExternalBrandHeroSectionProps) => {
  const isMobile = useThemeMediaQuery('below_sm');
  const { heroImage, heroImageMobile } = heroImageData;
  return (
    <>
      <StyledSection as="section" id={`${idPrefix}Hero`}>
        <HeroVideoContainer>
          <HeroWrapper>
            <HeroCloudImage
              src={isMobile ? heroImageMobile : heroImage}
              isEagerLoading
              width="100%"
              height="100%"
              optimization="aggressive"
            />
          </HeroWrapper>
        </HeroVideoContainer>
        <RegistryHeroTextColumn verticalAlign="center">
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} paddingLeft={[4, 12]} alignItems={['center', 'flex-start']}>
              <HeroTextPairing
                title={ReactHtmlParser(heroData.title)}
                titleVariant="hed72Hero"
                titleColor="mono7"
                titleTagName="h1"
                alignment={'left'}
                eyebrow={heroData.eyebrow}
                eyebrowColor="mono7"
                eyebrowVariant="sectionEyeBrow20"
              />
              <ButtonsContainer>
                <StyledGetStartedButton id={`${idPrefix}CreateRegistryBtn`} variant="secondary" page={page}>
                  {heroData.createRegistry}
                </StyledGetStartedButton>
                <StyledButton
                  id={`${idPrefix}ConnectBtn`}
                  variant="darkfindACoupleBtn"
                  forwardedAs="a"
                  href={getRootUrl(`/shop/brand/${brand}`)}
                >
                  {heroData.connectBrandRegistry}
                </StyledButton>
              </ButtonsContainer>
            </Flex>
          </Columns.Column>
        </RegistryHeroTextColumn>
      </StyledSection>
    </>
  );
};
